import { CheckResultDualUse } from '@solid/shared';
import React from 'react';
import { DUAL_USE_CATEGORY_LINK_MAP, DUAL_USE_CATEGORY_NAME_MAP, DUAL_USE_RESULT } from '../../services/check.service';
import CheckNoteForm from './CheckNoteForm';
import * as Styled from './CheckResultDualUse.styles';
import { Trans, useTranslation } from 'react-i18next';

interface CheckResultDualUseProps {
  result: CheckResultDualUse;
  checkId: string | number;
  note: string;
}

const CheckResultPageDualUse: React.FC<CheckResultDualUseProps> = ({ result, checkId, note }) => {
  const { t } = useTranslation();

  let header = '';
  let resultingElement: JSX.Element = <p>Ein Fehler ist aufgetreten.</p>;

  switch (result.type) {
    case DUAL_USE_RESULT.NO_DUAL_USE: {
      header = t('checks.checkResultDualUse.noDualUseTitle');
      resultingElement = (
        <Styled.Result>
          <Trans
            i18nKey='checks.checkResultDualUse.noDualUseResult'
            components={{
              b: <b />,
              p: <p />,
            }}
          />
        </Styled.Result>
      );
      break;
    }
    case DUAL_USE_RESULT.MILITARY: {
      header = t('checks.checkResultDualUse.militaryTitle');
      resultingElement = (
        <Styled.Result>
          <Trans
            i18nKey='checks.checkResultDualUse.militaryResult'
            components={{
              a: (
                <a
                  className='btn'
                  href='https://www.bafa.de/SharedDocs/Downloads/DE/Aussenwirtschaft/afk_gueterlisten_ausfuhrliste_abschnitt_a.pdf?__blob=publicationFile&v=7'
                  target='_blank noopener noreferrer'
                />
              ),
              i: <i />,
              p: <p />,
              br: <br />,
            }}
          />
        </Styled.Result>
      );
      break;
    }
    case DUAL_USE_RESULT.NATIONAL: {
      header = t('checks.checkResultDualUse.nationalTitle');
      resultingElement = (
        <Styled.Result>
          <Trans i18nKey='checks.checkResultDualUse.nationalResult' components={{ b: <b />, p: <p /> }} />
        </Styled.Result>
      );
      break;
    }
    case DUAL_USE_RESULT.CATEGORIES_LIST: {
      header = t('checks.checkResultDualUse.categoriesTitle');
      resultingElement = (
        <Styled.Result>
          <Trans i18nKey='checks.checkResultDualUse.categoriesResult' components={{ p: <p /> }} />

          <Styled.ResultCategories>
            {result.categories?.map(cat => (
              <a
                key={cat}
                className='btn is-primary'
                href={DUAL_USE_CATEGORY_LINK_MAP[cat]}
                target='_blank'
                rel='noreferrer'>
                {t('checks.checkResultDualUse.category', {
                  categoryNumber: cat,
                  categoryName: DUAL_USE_CATEGORY_NAME_MAP[cat],
                })}
              </a>
            ))}
          </Styled.ResultCategories>
          <Trans i18nKey='checks.checkResultDualUse.categoriesResult2' components={{ p: <p />, b: <b /> }} />
        </Styled.Result>
      );
    }
  }

  return (
    <Styled.CheckResultDualUse>
      <h1>{header}</h1>
      {resultingElement}

      <Styled.NoteContainer>
        <CheckNoteForm note={note} initialNote={t('checks.checkResultDualUse.initialNote')} />
      </Styled.NoteContainer>
    </Styled.CheckResultDualUse>
  );
};

export default CheckResultPageDualUse;
